export const truckColor = [
    '#7fc97f',
    '#51a7f9',
    '#ff69b4'
];

export const transitionDuration = 2000;
